import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { newToastEvent } from "../../../utils/ToastUtil";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import Constants from "../../../utils/Constants";

const useCreateIssues = () => {
  const createIssues = useMutation({
    mutationFn: async ({
      payload,
    }: {
      payload: any;
      onSuccess?: (data: any) => void;
      onError?: (error: any) => void;
    }) => {
      return TenantAPI.insertRecords(
        Constants.SPRINTS_ISSUES_API_NAME,
        payload,
        Constants.SPRINTS_TENANT_ID
      );
    },
    onSuccess: (data, { onSuccess }) => {
      newToastEvent("success", "Issue created successfully");
      callFunctionIfExists(onSuccess, data);
    },
    onError: (error: any) => {
      callFunctionIfExists(error?.onError, error);
    },
  });

  return {
    createIssues: createIssues.mutate,
    createIssueLoading: createIssues.isPending,
    createIssueError: createIssues.error,
    createIssueResult: createIssues.data,
  };
};

export default useCreateIssues;
